// custom js
// inventory modal js
document.addEventListener("DOMContentLoaded", function () {

  const modal = document.getElementById("inventoryModal");
  if (!modal) {
    console.error("Modal not found");
    return;
  }

  const overlay = modal.querySelector(".inventory-modal__overlay");
  const closeBtn = modal.querySelector(".inventory-modal__close");

  const inquireContent = modal.querySelector("#modal-inquire");
  const customizeContent = modal.querySelector("#modal-customize");

  const inquireButtons = document.querySelectorAll(".js-inquire");
  const customizeButtons = document.querySelectorAll(".js-customize");


  function openModal(type, productTitle, productUrl) {

    modal.classList.add("is-active");
    document.body.style.overflow = "hidden";

    // hide all
    if (inquireContent) inquireContent.style.display = "none";
    if (customizeContent) customizeContent.style.display = "none";

    // show correct
    if (type === "inquire" && inquireContent) {
      inquireContent.style.display = "block";
    }

    if (type === "customize" && customizeContent) {
      customizeContent.style.display = "block";
    }

    modal.setAttribute("data-product-title", productTitle || "");
    modal.setAttribute("data-product-url", productUrl || "");
  }

  function closeModal() {
    modal.classList.remove("is-active");
    document.body.style.overflow = "";
  }

  // INQUIRE
  inquireButtons.forEach(btn => {
    btn.addEventListener("click", function () {
      openModal(
        "inquire",
        this.dataset.product,
        this.dataset.url
      );
    });
  });

  // CUSTOMIZE
  customizeButtons.forEach(btn => {
    btn.addEventListener("click", function () {
      openModal(
        "customize",
        this.dataset.product,
        this.dataset.url
      );
    });
  });

  // CLOSE
  if (closeBtn) closeBtn.addEventListener("click", closeModal);
  if (overlay) overlay.addEventListener("click", closeModal);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeModal();
  });

});


// add the product name and url to the hulk form iframe as parameter
document.addEventListener("DOMContentLoaded", function () {

  const modal = document.getElementById("inventoryModal");

  function fillInquireForm(productName) {
    const input = document.querySelector("#modal-inquire .product-name");
    if (input) input.value = productName;
  }

  function updateIframe(productName, productUrl) {
    const iframe = document.querySelector("#modal-customize iframe");
    if (!iframe) return;

    const url = new URL(iframe.src);

    // Remove old values
    url.searchParams.delete("product");
    url.searchParams.delete("product_url");

    // Set new values
    url.searchParams.set("product", productName);
    url.searchParams.set("product_url", productUrl);

    iframe.src = url.toString();
  }

  document.addEventListener("click", function (e) {

    const inquireBtn = e.target.closest(".js-inquire");
    const customizeBtn = e.target.closest(".js-customize");

    if (inquireBtn) {
      const name = inquireBtn.dataset.product;
      const url = inquireBtn.dataset.url;

      fillInquireForm(name);
    }

    if (customizeBtn) {
      const name = customizeBtn.dataset.product;
      const url = customizeBtn.dataset.url;

      updateIframe(name, url);
    }

  });

});


// form submit scroll to top fix
let lastScroll = 0;

document.addEventListener("click", function (e) {
  if (e.target.closest(".form_submit_div button")) {
    lastScroll = window.scrollY;
  }
});

const observer = new MutationObserver(() => {
  if (lastScroll > 0) {

    for (let i = 0; i < 5; i++) {
      setTimeout(() => {
        window.scrollTo(0, lastScroll);
      }, i * 50);
    }

  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// booking trigger
document.addEventListener("click", function (e) {

  const consultationBtn = e.target.closest(".js-consultation");
  const homeEditBtn = e.target.closest(".js-home-edit");

  if (consultationBtn) {
    triggerBooking("in-home-consultation");
  }

  if (homeEditBtn) {
    triggerBooking("room-refresh-home-edit");
  }

  function triggerBooking(handle) {

    const productLink = document.querySelector(`a[href*="${handle}"]`);
    if (!productLink) {
      console.warn("Product not found:", handle);
      return;
    }

    const card = productLink.closest(".card");
    const bookBtn = card?.querySelector(".cowlendar-btn");

    if (!bookBtn) {
      console.warn("Cowlendar button not found:", handle);
      return;
    }

    //  IMPORTANT: ensure element is clickable even if hidden
    const parentSection = card.closest("section, .shopify-section");

    if (parentSection) {
      parentSection.style.display = "block";
      parentSection.style.visibility = "hidden"; // prevent flicker
    }

    // Small delay to allow DOM repaint
    setTimeout(() => {
      bookBtn.click();

      // Optional: hide again after triggering
      setTimeout(() => {
        if (parentSection) {
          parentSection.style.display = "";
          parentSection.style.visibility = "";
        }
      }, 300);

    }, 50);
  }

});